import { render, staticRenderFns } from "./BestProduct.vue?vue&type=template&id=51a4be2f"
import script from "./BestProduct.vue?vue&type=script&lang=js"
export * from "./BestProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports